import { Skeleton } from 'antd';

/**
 * Copia las medidas de `VanCard` para que al llegar los datos la grilla no se
 * reacomode: portada, dos líneas, tags y los dos slots de tripulación.
 */
function VanCardSkeleton() {
  return (
    <div className="vans-card vans-card--skeleton">
      <div className="vans-card__cover">
        <Skeleton.Node active style={{ width: '100%', height: 150 }}>
          <span />
        </Skeleton.Node>
      </div>

      <div className="vans-card__body">
        <Skeleton
          active
          title={{ width: '45%' }}
          paragraph={{ rows: 1, width: ['70%'] }}
        />
        <div className="vans-card__distributors">
          <Skeleton.Button
            active
            size="small"
            style={{ width: 72, height: 22 }}
          />
          <Skeleton.Button
            active
            size="small"
            style={{ width: 88, height: 22 }}
          />
        </div>
      </div>

      <div className="vans-card__crew">
        {[0, 1].map((slot) => (
          <div className="vans-crew-slot" key={slot}>
            <Skeleton.Avatar active size={36} />
            <div className="vans-crew-slot__info">
              <Skeleton
                active
                title={{ width: '55%' }}
                paragraph={{ rows: 1, width: ['78%'] }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VanCardSkeleton;
